import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import plusCircle from "../../assets/icons/plusCircle.svg";
import grid from "../../assets/icons/grid.svg";
import formBuilderIcon from "../../assets/icons/formBuilderIcon.svg";
import spireBlackLogo from "../../assets/icons/spireBlackLogo.svg";
import TemplateBuilder from "../../assets/icons/TemplateBuilder.svg";
import edit from "../../assets/icons/edit-2.svg";
import AddCompanyPopup from "../../components/Dailogs/AddCompanyModal";
import Loader from "../../components/Dailogs/Loader";
import Header from "../../layouts/Header";
import {
  AddCompanyInfo,
  FetchCompanyDetailsById,
  FetchInvoiceSettingList,
  UpdateCompanyDetails,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import "../../assets/styles/local/Settings2.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import translate from "../../assets/icons/translation.svg";
import planboard from "../../assets/icons/planboard.svg";
import invoiceBlack from "../../assets/icons/InvoiceBlack.svg";
import PhoneInput from "react-phone-input-2";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { Tooltip, Progress, Empty } from "antd";

const Settings2 = () => {
  const history = useHistory();

  const companyid = window.localStorage.getItem("companyid");
  const packageID = window.localStorage.getItem("packageId");

  const [typeComp, setTypeComp] = useState("");
  const [add_image, setAdd_image] = useState("");
  const [canGoBack, setCanGoBack] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modal, setModal] = useState(false);
  const addCompanyDetails = useSelector(
    (state) => state.user.addCompanyDetails,
  );
  const [toucehd, setTouched] = useState(false);
  const FetchCompanyDetails = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const showAdvancedTaskSystem = useSelector(
    (state) => state.user.showAdvancedTaskSystem,
  );
  const handleCancel = (e) => {
    if (toucehd) {
      setModal(true);
    } else {
      history.goBack();
    }
  };
  const handleCancelForce = (e) => {
    history.goBack();
  };
  const dispatch = useDispatch();
  const [loadingPage, setLoadingPage] = useState(true);

  const isPlus = useMemo(() => {
    return window.localStorage.getItem("hasPlus") == "true";
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-overview").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (FetchCompanyDetails !== null) {
      if (FetchCompanyDetails?.status === true) {
        setLoadingPage(true);
        dispatch(
          FetchCompanyDetailsById({
            comapnyid: FetchCompanyDetails.data[0]?.companyid,
          }),
        )
          .then(() => {
            setLoadingPage(false);
          })
          .catch(() => {
            setLoadingPage(false);
          });
      }
    }
  }, [FetchCompanyDetails]);

  useEffect(() => {
    dispatch(FetchInvoiceSettingList(companyid, 0, 0));
  }, []);

  const [disabled, setDisable] = useState(true);

  const fileInputRef = useRef(null);
  const [companyDetails, setCompanyDetails] = useState({
    companyname: "",
    documentLogo: "",
    address: "",
    phonenumber: "",
    email: "",
    vatnumber: "",
    website: "",
    kvkNo: "",
    iban: "",
    bicNo: "",
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });

  useEffect(() => {
    if (
      FetchCompanyDetails?.data[0]?.companyid &&
      addCompanyDetails?.data?.companyname
    ) {
      const companyDetail = {
        companyid: FetchCompanyDetails.data[0]?.companyid,
        companyname: addCompanyDetails.data.companyname,
        documentLogo: addCompanyDetails.data.documentLogo,
        address: addCompanyDetails.data.address,
        phonenumber: addCompanyDetails.data.telephonenumber,
        email: addCompanyDetails.data.email,
        vatnumber: addCompanyDetails.data.vaTnumber,
        website: addCompanyDetails.data.website,
        kvkNo: addCompanyDetails.data.kvkNo,
        iban: addCompanyDetails.data.iban,
        bicNo: addCompanyDetails.data.bicNo,
        street:
          addCompanyDetails.data.streetWithNumber ||
          addCompanyDetails.data.street ||
          "",
        city: addCompanyDetails.data.city || "",
        state: addCompanyDetails.data.state || "",
        pinCode:
          addCompanyDetails.data.pinCode ||
          addCompanyDetails.data.pincode ||
          addCompanyDetails.data.postalCode ||
          "",
        country: addCompanyDetails.data.country || "",
      };
      setCompanyDetails(companyDetail);
    }
  }, [addCompanyDetails]);

  const handleImageClick = () => {
    setTouched(true);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const target = e.target.files[0];
    if (target) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const imageData = event.target.result;
        setAdd_image(imageData);
      };

      reader.readAsDataURL(target);
    }
    let formData = new FormData();
    formData.append("file", target);

    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setCompanyDetails({
            ...companyDetails,
            documentLogo: response.data[0],
          });
        } else {
        }
      })
      .catch(function (error) {});
    // alert(target.name + " " + "File is Attached in comment box");
  };

  const handleFileChange_newToconvertIn_PNG = (e) => {
    const target = e.target.files[0];
    if (target) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // CORS issue avoid karne ke liye
        img.src = event.target.result;

        img.onload = async () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width; // original width
          canvas.height = img.height; // original height
          canvas.getContext("2d").drawImage(img, 0, 0);

          const pngDataUrl = canvas.toDataURL("image/png");

          setAdd_image(pngDataUrl);

          const blob = await (await fetch(pngDataUrl)).blob();
          const pngFile = new File(
            [blob],
            target.name.replace(/\.[^/.]+$/, "") + ".png",
            { type: "image/png" },
          );

          let formData = new FormData();
          formData.append("file", pngFile);

          axios
            .put(`${API_URL}/api/Files/UploadToS3`, formData)
            .then(function (response) {
              if (response !== null) {
                setCompanyDetails({
                  ...companyDetails,
                  documentLogo: response.data[0],
                });
              }
            })
            .catch(function (error) {
              console.error("Upload error:", error);
            });
        };
      };
      reader.readAsDataURL(target);
    }
  };

  const [loading, setLoading] = useState(false);
  const [companyDetailsError, setCompanyDetailsError] = useState({});

  // Ananya code ===

  const [emailError, setEmailError] = useState("");

  const handleAdd = async () => {
    const errors = {};
    // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      !emailPattern.test(companyDetails.email) &&
      companyDetails.email.trim() !== ""
    ) {
      errors.email = "Invalid email format";
    } else {
      setLoading(true);
      if (companyDetails?.companyid) {
        await dispatch(UpdateCompanyDetails(companyDetails));
        // setCanGoBack(true);
      } else {
        await dispatch(AddCompanyInfo(companyDetails));
        // setCanGoBack(true);
      }
    }
    setLoading(false);
    // history.goBack("");
    setCanGoBack(true);
    setTouched(false);
  };

  // Old code ===

  // const handleAdd = async () => {
  //   const errors = {};
  //   let hasError = false;

  //   const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  //   if (!emailPattern.test(companyDetails.email) && companyDetails.email.trim() !== "") {
  //     errors.email = "Invalid email format";
  //     hasError = true;
  //   }

  //   if (hasError) {
  //     setCompanyDetailsError(errors);
  //   } else {
  //     setLoading(true)
  //     setCompanyDetailsError({});
  //     if (companyDetails?.companyid) {
  //       await dispatch(UpdateCompanyDetails(companyDetails))
  //     } else {
  //       await dispatch(AddCompanyInfo(companyDetails))
  //     }

  //     setLoading(false)
  //   }
  //   history.goBack("")
  // };

  // postal Code start
  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  const getAddressParts = (parsed = {}) => ({
    street: parsed.streetWithNumber || parsed.street || "",
    city: parsed.city || "",
    state: parsed.state || "",
    pinCode: parsed.pinCode || parsed.postalCode || "",
    country: parsed.country || "",
  });

  const handleAddressSelect = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);
      setPinCodeForAdress(parsed.postalCode);
      setCompanyDetails({
        ...companyDetails,
        address: parsed.formattedAddress,
        ...getAddressParts(parsed),
      });
    } catch (err) {
      console.log("Error while fetching address meta ", err);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // postal Code end

  return (
    <>
      <Header
        leftComponent={
          <div className="d-flex flex-wrap align-items-baseline gap-4">
            <div className="projectText" style={{ color: "#333333" }}>
              {/* Settings */}
              {t("Settings")}
            </div>
          </div>
        }
      />
      {loadingPage ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div
          style={{
            background: "#FAFAFA",
          }}
          className="container-fluid"
        >
          <div
            className="container-fluid scrollWidth"
            style={{
              borderTopLeftRadius: "0px",
            }}
          >
            <div className="container-fluid gx-6 row col-12 pe-0">
              <div className="container-fluid sub col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 inMobile">
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    disabled={disabled}
                    style={{
                      cursor: `${disabled ? "not-allowed" : "pointer"}`,
                      opacity: disabled ? 0.5 : 1,
                    }}
                    type="button"
                    className="Cancel me-4"
                    onClick={() => {
                      handleCancel();
                    }}
                  >
                    {/* Cancel */}
                    {t("Cancel ")}
                  </button>

                  <button
                    disabled={disabled}
                    style={{
                      cursor: `${disabled ? "not-allowed" : "pointer"}`,
                      opacity: disabled ? 0.5 : 1,
                    }}
                    type="button"
                    className="Add"
                    onClick={handleAdd}
                  >
                    {
                      loading ? (
                        <div className="gap-1 d-flex justify-content-center align-items-center">
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                          {companyDetails?.companyid ? (
                            <span>
                              {/* Updating... */}
                              {t("Updating")}...
                            </span>
                          ) : (
                            <span>
                              {/* Adding... */}
                              {t("Adding")}...
                            </span>
                          )}
                        </div>
                      ) : companyDetails?.companyid ? (
                        <span>
                          {t("Change")}
                          {/* Change */}
                        </span>
                      ) : (
                        <span>
                          {t("Add")}
                          {/* Add */}
                        </span>
                      )
                      // "Add"
                    }
                  </button>
                </div>

                <div className="row details">
                  <div className="container-fluid sub  ps-0 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 translation inMobile left-inMobile">
                    <div className="st-fc" style={{ marginTop: "40px" }}>
                      <div
                        className="st-settings-tabs mb-3"
                        onClick={() => {
                          history.push("/my-plan");
                        }}
                      >
                        <img src={grid} alt="" />
                        {/* My Plan  */}
                        {t("My Plan")}
                      </div>

                      <div
                        className="st-settings-tabs"
                        onClick={() => {
                          history.push("/settings-language");
                        }}
                      >
                        <img src={translate} alt="" />
                        {/* Translations  */}
                        {t("Translations")}
                      </div>

                      {packageID === process.env.REACT_APP_IS_PREMIUM &&
                        // planboard will not show for interko 👇.
                        companyid !== "28830f30-b321-4662-a576-f23451677742" &&
                        showAdvancedTaskSystem && (
                          <div
                            className="st-settings-tabs"
                            onClick={() => {
                              history.push("/settings-planboard");
                            }}
                          >
                            <img src={planboard} alt="" />
                            {/* Planboards  */}
                            {t("Planboards")}
                          </div>
                        )}

                      {!isPlus && (
                        <div
                          className="st-settings-tabs"
                          onClick={() => {
                            history.push("/invoices-settings", {
                              email: companyDetails?.email,
                              address: companyDetails?.address,
                              phonenumber: companyDetails?.phonenumber,
                              street: companyDetails?.street,
                              city: companyDetails?.city,
                              state: companyDetails?.state,
                              pinCode: companyDetails?.pinCode,
                              country: companyDetails?.country,
                            });
                          }}
                        >
                          <img src={invoiceBlack} alt="" />
                          {/* Invoice Settings  */} {t("Invoice Settings")}
                        </div>
                      )}

                      <div
                        className="st-settings-tabs mb-3"
                        onClick={() => {
                          history.push("/workflow-automation");
                        }}
                      >
                        <img src={formBuilderIcon} alt="" />
                        {/* Workflow Automation  */} {t("Workflow Automation")}
                      </div>

                      <div
                        className="st-settings-tabs mb-3"
                        onClick={() => {
                          history.push("/form-poc");
                        }}
                      >
                        <img src={formBuilderIcon} alt="" />
                        {/* Form Builder  */} {t("Form Builder")}
                      </div>

                      <div
                        className="st-settings-tabs mb-3"
                        onClick={() => {
                          history.push("/spire-connect");
                        }}
                      >
                        <img src={spireBlackLogo} alt="" />
                        {/* Spire Connect  */} {t("Spire Connect")}
                      </div>

                      <div
                        className="st-settings-tabs mb-3"
                        onClick={() => {
                          history.push("/template-builder");
                        }}
                      >
                        <img
                          src={TemplateBuilder}
                          alt=""
                          className="custom-filter"
                        />
                        {/* Templates Builder */} {t("Templates Builder")}
                      </div>
                    </div>
                  </div>

                  <div className="details1 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Company Name */} {t("Company Name")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.companyname}
                        onChange={(e) => {
                          setTypeComp(e.target.value);
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            companyname: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        // placeholder="Enter Company Name "
                        placeholder={t("Enter Company Name")}
                      />
                    </div>

                    <div
                      className="asc-input-container componentA-container"
                      id="ascInput"
                    >
                      {/* <label className="asc-label-top ComapnyAddressText">
                        Delivery Address
                      </label>

                      <textarea
                        rows="50"
                        onFocus={() => setTouched(true)}
                        cols="50"
                        value={companyDetails.address}
                        onChange={(e) => {
                          setDisable(false)
                          setCompanyDetails({ ...companyDetails, address: e.target.value })
                        }}
                        className="CompanyInput ps-4"
                        placeholder="Add an address"
                      ></textarea> */}

                      <div
                        style={{
                          position: "relative",
                          borderRadius: "5px",
                          border: "1px solid #70707080",
                          padding: "10px",
                        }}
                      >
                        <label
                          style={{
                            position: "absolute",
                            top: "-10px",
                            left: "10px",
                            color: "#7E7E7E",
                            backgroundColor: "#fff",
                            padding: "0 5px",
                            fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                          }}
                        >
                          {/* Address  */} {t("Address")}
                        </label>
                        <GooglePlacesAutocomplete
                          debounce={800}
                          renderInput={(props) => (
                            <textarea
                              onFocus={() => {
                                setTouched(true);
                              }}
                              style={{
                                border: "none",
                                width: "100%",
                                overflow: "hidden",
                                fontSize: "clamp(14px, 0.833vw, 0.833vw)",
                              }}
                              {...props}
                              onChange={(e) => {
                                props.onChange?.(e);
                                setCompanyDetails({
                                  ...companyDetails,
                                  street: "",
                                  city: "",
                                  state: "",
                                  pinCode: "",
                                  country: "",
                                });
                              }}
                              rows={4}
                              placeholder=""
                            />
                          )}
                          onSelect={(e) => {
                            setDisable(false);
                            handleAddressSelect(e);
                          }}
                          initialValue={companyDetails.address}
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Contact Email */}
                        {t("Contact Email")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.email}
                        onChange={(e) => {
                          // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                          // ASC new format below
                          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          const email = e.target.value;

                          if (
                            !emailPattern.test(email) &&
                            email.trim() !== ""
                          ) {
                            setEmailError("Invalid email format");
                          } else {
                            setEmailError("");
                          }
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            email: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        placeholder="Add an email"
                      />
                      {emailError && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          {emailError}
                        </span>
                      )}
                      {/* {companyDetailsError.email && (
                        <span style={{ color: 'red', fontSize: '13px' }}>{companyDetailsError.email}</span>)
                      } */}
                    </div>

                    <div className="asc-input-container col-12" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Telephone  */} {t("Telephone")}
                      </label>
                      {/* <input
                          className="contactDeliveryInput ps-4 pt-1"
                          onFocus={() => setTouched(true)}
                          value={companyDetails.phonenumber}
                          onChange={(e) => {
                            setDisable(false);
                            setCompanyDetails({
                              ...companyDetails,
                              phonenumber: e.target.value,
                            });
                          }}
                          placeholder="Telephone Number"
                        /> */}

                      <PhoneInput
                        country={"nl"}
                        enableSearch={true}
                        className="contactDeliveryInput ps-4 pt-1"
                        placeholder="Telephone Number"
                        value={companyDetails.phonenumber}
                        onChange={(phone) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            phonenumber: phone,
                          });
                        }}
                      />
                    </div>

                    <div className="asc-input-container col-12" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* VAT No. */}
                        {t("VAT No.")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.vatnumber}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            vatnumber: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        placeholder="Add VAT No."
                      />
                    </div>

                    <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Website  */}
                        {t("Website")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.website}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            website: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        // placeholder="Add a website"
                        placeholder={t("Website")}
                      />
                    </div>

                    <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* IBAN   */}
                        {t("IBAN")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.iban}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            iban: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        // placeholder="Add a website"
                        placeholder={t("IBAN")}
                      />
                    </div>

                    <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* BICNo   */}
                        {t("BICNo")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.bicNo}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            bicNo: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        // placeholder="Add a website"
                        placeholder={t("BICNo")}
                      />
                    </div>

                    {/* <div className="asc-input-container" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        Kvk No.
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.kvkNo}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            kvkNo: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        placeholder="Kvk no."
                      />
                    </div> */}
                  </div>

                  <div className="details2 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <div
                      className="asc-input-container input-kvk-container"
                      id="ascInput"
                    >
                      <label className="asc-label-top projectNameText">
                        {/* Kvk No.  */}
                        {t("kvk No.")}
                      </label>
                      <input
                        type="text"
                        onFocus={() => setTouched(true)}
                        value={companyDetails.kvkNo}
                        onChange={(e) => {
                          setDisable(false);
                          setCompanyDetails({
                            ...companyDetails,
                            kvkNo: e.target.value,
                          });
                        }}
                        className="contactDeliveryInput ps-4"
                        placeholder="Kvk no."
                      />
                    </div>
                    <p className="companyLogoText">
                      {/* Company Logo  */} {t("Company Logo")}
                    </p>
                    <div className="addPicture" id="ascInput">
                      <div
                        className={
                          add_image || companyDetails?.documentLogo
                            ? ""
                            : "flexProperty mt-5 pt-2"
                        }
                      >
                        {add_image || companyDetails?.documentLogo ? (
                          <img
                            src={add_image || companyDetails?.documentLogo}
                            style={{ width: "120px" }}
                            className="addImg"
                            alt=""
                          />
                        ) : (
                          <img
                            onClick={handleImageClick}
                            src={plusCircle}
                            className="plusImg"
                            alt=""
                          />
                        )}

                        <input
                          type="file"
                          onFocus={() => setTouched(true)}
                          accept="image/png"
                          ref={fileInputRef}
                          onChange={(e) => {
                            setDisable(false);
                            handleFileChange(e);
                          }}
                          style={{ display: "none" }}
                        />
                      </div>

                      <p
                        className={
                          add_image || companyDetails?.documentLogo
                            ? "d-none"
                            : "Picture"
                        }
                      >
                        {/* Add or drag a picture */}{" "}
                        {t("Add or drag a picture")}
                      </p>
                      <div style={{ height: "5-0px" }}>
                        {/* {imageurl && ( */}

                        {/* uncomment for edit option below start */}

                        <Tooltip
                          title={"Support only PNG format"}
                          color={"white"}
                          overlayInnerStyle={{
                            color: "black",
                            fontWeight: "500",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-center pt-3 ">
                            <h6
                              style={{
                                fontSize: "clamp(12px, 0.729vw, 0.729vw)",
                                fontWeight: 400,
                                cursor: "pointer",
                                color: "#A5A5A5",
                                wordBreak: "break-all",
                              }}
                              onClick={handleImageClick}
                            >
                              {/* Edit  */} {t("Edit")}
                            </h6>
                            <img
                              className="mx-2"
                              style={{ cursor: "pointer" }}
                              src={edit}
                              alt="Edit"
                              onClick={handleImageClick}
                            />
                          </div>
                        </Tooltip>

                        {/* uncomment for edit option above end */}

                        {/* )} */}
                      </div>
                      {/* <p>
                        300x300 pixels jpg or png format
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {modal && (
        <AddCompanyPopup
          show={modal}
          onHide={() => setModal(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancelForce}
        />
      )} */}

      <RouteLeavingGuard
        when={toucehd}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (toucehd) {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
    </>
  );
};

export default Settings2;
